import { render, staticRenderFns } from "./searchUser.vue?vue&type=template&id=f5c9d44a&scoped=true&"
import script from "./searchUser.vue?vue&type=script&lang=ts&"
export * from "./searchUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c9d44a",
  null
  
)

export default component.exports